// Sessione Minerva (fase 3d): il token sta in un cookie HttpOnly impostato dal backend
// (__Host-minerva_sessione su minervanginx.myetms.it). Il browser lo manda da solo con
// `credentials: "include"`; JavaScript non lo vede e qui non si salva mai.
// Nel browser resta solo `user_data` (nome, ruolo, moduli): stato dell'interfaccia, non un segreto.
import API_BASE_URL from "../api";

const CHIAVI_VECCHIE = ["token", "authToken", "access_token"];

// Token salvati dalle versioni precedenti: non servono piu' e non devono restare leggibili.
export function rimuoviTokenVecchi() {
  for (const k of CHIAVI_VECCHIE) {
    try { sessionStorage.removeItem(k); } catch (e) { /* storage non disponibile */ }
    try { localStorage.removeItem(k); } catch (e) { /* storage non disponibile */ }
  }
}

export function salvaUtente(utente) {
  const json = JSON.stringify(utente);
  sessionStorage.setItem("user_data", json);
  // Copia condivisa: una scheda nuova riparte da qui (index.js). La sessione vera
  // e' il cookie, che il browser condivide gia' tra le schede.
  localStorage.setItem("user_data", json);
}

function dimenticaUtente() {
  try { sessionStorage.removeItem("user_data"); } catch (e) { /* */ }
  try { localStorage.removeItem("user_data"); } catch (e) { /* */ }
  rimuoviTokenVecchi();
}

// Logout vero: il backend cancella il cookie. Anche se la chiamata fallisce (rete,
// sessione gia' scaduta) lo stato locale si pulisce comunque.
export async function chiudiSessione() {
  try {
    await fetch(`${API_BASE_URL}/logout`, { method: "POST" });
  } catch (e) {
    // si prosegue: il cookie scade comunque da solo
  }
  dimenticaUtente();
}

// Indirizzi Firebase ancora nei preferiti di qualcuno: da li' il cookie di myetms.it
// non parte (sito diverso). Si reindirizza al dominio giusto mantenendo il percorso.
// Solo per i nomi *.firebaseapp.com / *.web.app: se minerva.myetms.it tornasse su Firebase
// (rollback DNS) il nome resta minerva.myetms.it e qui non succede nulla.
export function reindirizzaDaFirebase() {
  const host = window.location.hostname;
  if (host.endsWith(".firebaseapp.com") || host.endsWith(".web.app")) {
    const { pathname, search, hash } = window.location;
    window.location.replace(`https://minerva.myetms.it${pathname}${search}${hash}`);
    return true;
  }
  return false;
}
